var d3dat = (function (lib) {

	lib.version = '1.0';

	return lib;




}(d3dat || {}));
